const EXECUTION_POLICY_MAP = {
  local_preferred: '本地优先（适合立即发布）',
  cloud_preferred: '云端优先（适合定时任务）',
  local_only: '仅本地执行（用于本机强依赖场景）',
  cloud_only: '仅云端执行（用于无人值守场景）',
};

const FALLBACK_POLICY_MAP = {
  manual_only: '仅手动切换（推荐）',
  allow_fallback: '允许自动回退（失败自动切换）',
};

const AGENT_TYPE_MAP = {
  local: '本地',
  cloud: '云端',
};

const normalize = (value) => String(value || '').trim().toLowerCase();

export const getExecutionPolicyLabel = (value) => {
  const key = normalize(value);
  if (!key) return '-';
  return EXECUTION_POLICY_MAP[key] || key;
};

export const getFallbackPolicyLabel = (value) => {
  const key = normalize(value);
  if (!key) return '-';
  return FALLBACK_POLICY_MAP[key] || key;
};

export const getAgentTypeLabel = (value) => {
  const key = normalize(value);
  if (!key) return '-';
  return AGENT_TYPE_MAP[key] || key;
};

export const formatAgentTypeList = (values) => {
  if (!Array.isArray(values) || values.length === 0) return '-';
  return values.map((value) => getAgentTypeLabel(value)).join('、');
};

export const EXECUTION_POLICY_SELECT_OPTIONS = [
  { label: '本地优先（适合立即发布）', value: 'local_preferred' },
  { label: '云端优先（适合定时任务）', value: 'cloud_preferred' },
  { label: '仅本地执行（用于本机强依赖场景）', value: 'local_only' },
  { label: '仅云端执行（用于无人值守场景）', value: 'cloud_only' },
];

export const AGENT_TYPE_SELECT_OPTIONS = [
  { label: '本地（用于立即发布）', value: 'local' },
  { label: '云端（用于定时任务）', value: 'cloud' },
];

export const FALLBACK_POLICY_SELECT_OPTIONS = [
  { label: '仅手动切换（推荐）', value: 'manual_only' },
  { label: '允许自动回退（失败自动切换）', value: 'allow_fallback' },
];
